"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stylable = void 0;
const create_stylable_processor_1 = require("./create-stylable-processor");
const diagnostics_1 = require("./diagnostics");
const parser_1 = require("./parser");
const stylable_processor_1 = require("./stylable-processor");
const stylable_resolver_1 = require("./stylable-resolver");
const stylable_transformer_1 = require("./stylable-transformer");
const module_resolver_1 = require("./module-resolver");
const deprecation_1 = require("./helpers/deprecation");
const features_1 = require("./features");
const postcss = __importStar(require("postcss"));
class Stylable {
    constructor(projectRoot, fileSystem, requireModule, delimiter = '__', onProcess, diagnostics = new diagnostics_1.Diagnostics(), hooks = {}, resolveOptions = {}, optimizer, mode = 'production', resolveNamespace, moduleResolver = (0, module_resolver_1.createDefaultResolver)(fileSystem, resolveOptions), cssParser = parser_1.cssParse, resolverCache, // ToDo: v5 default to `new Map()`
    // This cache is fragile and should be fresh if onProcess/resolveNamespace/cssParser is different
    fileProcessorCache) {
        this.projectRoot = projectRoot;
        this.fileSystem = fileSystem;
        this.requireModule = requireModule;
        this.delimiter = delimiter;
        this.onProcess = onProcess;
        this.diagnostics = diagnostics;
        this.hooks = hooks;
        this.resolveOptions = resolveOptions;
        this.optimizer = optimizer;
        this.mode = mode;
        this.resolveNamespace = resolveNamespace;
        this.moduleResolver = moduleResolver;
        this.cssParser = cssParser;
        this.resolverCache = resolverCache;
        this.fileProcessorCache = fileProcessorCache;
        this.stVar = new features_1.STVar.StylablePublicApi(this);
        this.fileProcessor = (0, create_stylable_processor_1.createStylableFileProcessor)({
            fileSystem,
            onProcess,
            resolveNamespace: this.resolveNamespace,
            cssParser,
            cache: this.fileProcessorCache,
        });
        this.resolver = this.createResolver();
    }
    static create(config) {
        return new this(config.projectRoot, config.fileSystem, (id) => {
            if (config.requireModule) {
                return config.requireModule(id);
            }
            throw new Error('Javascript files are not supported without requireModule options');
        }, config.delimiter, config.onProcess, config.diagnostics, config.hooks, config.resolveOptions, config.optimizer, config.mode, config.resolveNamespace, config.resolveModule, config.cssParser, config.resolverCache, config.fileProcessorCache);
    }
    initCache({ filter } = {}) {
        if (filter && this.resolverCache) {
            for (const [key, cacheEntity] of this.resolverCache) {
                const keep = filter(key, cacheEntity);
                if (!keep) {
                    this.resolverCache.delete(key);
                }
            }
        }
        else {
            this.resolverCache = new Map();
            this.resolver = this.createResolver();
        }
    }
    createResolver({ requireModule = this.requireModule, resolverCache = this.resolverCache, resolvePath = this.moduleResolver, } = {}) {
        return new stylable_resolver_1.StylableResolver(this.fileProcessor, requireModule, resolvePath, resolverCache);
    }
    createProcessor({ resolveNamespace = this.resolveNamespace, } = {}) {
        return new stylable_processor_1.StylableProcessor(new diagnostics_1.Diagnostics(), resolveNamespace);
    }
    /**@deprecated */
    createTransformer(options) {
        return this._createTransformer(options);
    }
    _createTransformer(options = {}) {
        return new stylable_transformer_1.StylableTransformer({
            delimiter: this.delimiter,
            moduleResolver: this.moduleResolver,
            diagnostics: new diagnostics_1.Diagnostics(),
            fileProcessor: this.fileProcessor,
            requireModule: this.requireModule,
            postProcessor: this.hooks.postProcessor,
            replaceValueHook: this.hooks.replaceValueHook,
            resolverCache: this.resolverCache,
            mode: this.mode,
            ...options,
        });
    }
    transform(meta, resourcePath, options = {}, processorOptions = {}) {
        if (typeof meta === 'string') {
            meta = this.createProcessor(processorOptions).process(this.cssParser(meta, { from: resourcePath }));
        }
        const transformer = this._createTransformer(options);
        this.fileProcessor.add(meta.source, meta);
        return transformer.transform(meta);
    }
    transformSelector(pathOrMeta, selector, options) {
        const meta = typeof pathOrMeta === `string` ? this.analyze(pathOrMeta) : pathOrMeta;
        const transformer = this._createTransformer(options);
        const r = transformer.scopeSelector(meta, selector, undefined, undefined, true);
        return {
            selector: r.selector,
            resolved: r.elements,
        };
    }
    transformCustomProperty(pathOrMeta, prop) {
        const meta = typeof pathOrMeta === `string` ? this.analyze(pathOrMeta) : pathOrMeta;
        return features_1.CSSCustomProperty.scopeCSSVar(this.resolver, meta, prop);
    }
    transformDecl(pathOrMeta, prop, value, options) {
        const decl = postcss.decl({ prop, value });
        this.transformAST(pathOrMeta, postcss.root({}).append(postcss.rule({ selector: `.x` }).append(decl)), options);
        return { prop: decl.prop, value: decl.value };
    }
    transformAST(pathOrMeta, ast, options) {
        const meta = typeof pathOrMeta === `string` ? this.analyze(pathOrMeta) : pathOrMeta;
        const transformer = this._createTransformer(options);
        transformer.transformAst(ast, meta);
        return ast;
    }
    /**@deprecated use stylable.analyze instead*/
    process(fullPath, invalidateCache = false) {
        (0, deprecation_1.warnOnce)('Stylable.process is deprecated, please use stylable.analyze instead');
        if (typeof invalidateCache === 'string') {
            (0, deprecation_1.warnOnce)('Stylable.process with context as second arguments is deprecated please resolve the fullPath with Stylable.resolvePath before using');
        }
        return this.fileProcessor.process(fullPath, invalidateCache);
    }
    analyze(fullPath, overrideSrc) {
        return overrideSrc
            ? this.fileProcessor.processContent(overrideSrc, fullPath)
            : this.fileProcessor.process(fullPath);
    }
    resolvePath(directoryPath, request) {
        return this.resolver.resolvePath(directoryPath, request);
    }
}
exports.Stylable = Stylable;
//# sourceMappingURL=stylable.js.map